import styled from 'types/theme.types';
import { LOCK_CONTAINER_ID } from 'stores/mobx/auth.store';
import React from 'react';

const StyledDiv = styled.div`
  margin-top: auto;
  .auth0-lock-cred-pane,
  .auth0-lock-header {
    background-color: transparent !important;
  }
  .auth0-lock-header,
  .auth0-sso-notice,
  .auth0-lock-alternative-link,
  .auth0-lock-form p {
    color: ${({ theme }) => theme.primaryBlack} !important;
  }
`;

const LockContainer = () => <StyledDiv data-e2e={LOCK_CONTAINER_ID} id={LOCK_CONTAINER_ID} />;

export default LockContainer;
